import {
    InstagramOutlined,
    LinkedinFilled,
    FacebookFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();
    return (
        <div
            className="bg-primary-blue flex items-center justify-between sm:pr-20 sm:flex-row flex-col pb-5 sm:pb-0 gap-y-5"
            style={{ minHeight: "100px" }}
        >
            <img
                src="/Logo.png"
                alt="sultana-homes-logo"
                style={{
                    height: "80px",
                    imageResolution: "from-image",
                }}
                onClick={() => navigate("/")}
                className="hover:cursor-pointer"
            />
            <div className="flex gap-x-10">
                <LinkedinFilled
                    style={{ fontSize: "30px" }}
                    className="text-primary-gold hover:cursor-pointer"
                />
                <FacebookFilled
                    style={{ fontSize: "30px" }}
                    className="text-primary-gold hover:cursor-pointer"
                />
                <InstagramOutlined
                    style={{ fontSize: "30px" }}
                    className="text-primary-gold hover:cursor-pointer"
                />
            </div>
        </div>
    );
};

export default Footer;
